export default __webpack_public_path__ + "static/media/profile.2b86651a.svg";